$(window).load(function () {
    // Check if it's the checkout review page
    setTimeout(() => {
    if ($('body').hasClass('checkoutPage') && ($('.checkout-header h1').text().toLowerCase() === 'checkout review')) {
        // Function to show the popup
        function showPopup() {
            const popupHTML = `
          <div id="cart-pop" class="cart-pop">
              <div class="cart-pop__content">
                  <h2>Important Notice</h2>
                  <p>All ticket sales are final. No refunds. Event is rain or shine. Please be sure you have selected the correct eclipse event, Total-ity Fun at the Fairgrounds in Hamburg, NY, and the correct number of tickets before completing your purchase (Carload ticket admits one vehicle and its passengers). The ticket holder agrees that all passengers of the vehicle will comply with all policies and protocols including health, safety and security at the time of the event. If you have any questions, call before you click.</p>
                  <div class="cart-pop__buttons">
                      <button id="cart-pop-btn-yes" class="button">I UNDERSTAND</button>
                      <button id="cart-pop-btn-no" class="button">BACK</button>
                  </div>
              </div>
          </div>
          `;
            $("body").prepend(popupHTML);
            // Add click event listeners to the buttons
            $("#cart-pop-btn-yes").on("keypress click", function (event) {
                if (event.key == "Enter" || event.type == "click") {
                    closePopup();
                }
            });
            $("#cart-pop-btn-no").on("keypress click", function (event) {
                if (event.key == "Enter" || event.type == "click") {
                    window.location.href = `${SITEBASEURL}checkout_info.aspx`;
                }
            });
            $(document).on("keydown", function (event) {
                if (event.key == "Escape") {
                    window.location.href = `${SITEBASEURL}checkout_info.aspx`;
                }
            });
        }
        // Function to close the popup
        function closePopup(continueTransaction) {
            $("#cart-pop").fadeOut("fast", function () {
                $("#cart-pop").remove();
            });
        }
        function trapFocus() {
            const firstFocusable = $("#cart-pop-btn-yes");
            const lastFocusable = $("#cart-pop-btn-no");

            firstFocusable.on("keydown", (event) => {
                if (event.key === "Tab") {
                    if (event.shiftKey) {
                        event.preventDefault();
                        lastFocusable.focus();
                    }
                }
            });

            lastFocusable.on("keydown", (event) => {
                if (event.key === "Tab") {
                    if (!event.shiftKey) {
                        event.preventDefault();
                        firstFocusable.focus();
                    }
                }
            });
        }


      
            // Check if product with product ID number is in the cart
            const isProductInCart = $('[data-product-id="404"]').length > 0;

            // Show popup if product is in the cart
            if (isProductInCart) {
                showPopup();
                trapFocus();
            }

        

    }
}, 1000);
});